import { useTranslation } from "react-i18next";
import { ReactComponent as InstagramSvg } from "../../../assets/icons/instagram.svg";
import { ReactComponent as TikTokSvg } from "../../../assets/icons/tiktok.svg";
import { item } from '../../utils/animations';
import styles from './FooterSubSections.module.css';
import { motion } from 'framer-motion';

export const FooterFollowUs = () => {
    const { t } = useTranslation();
    const handleInstagramClick = () => {
        window.open(
            "https://www.instagram.com/gluten.freends?igsh=MTc1b2xjOTNnNW9icQ%3D%3D&utm_source=qr",
            "_blank"
        )
    }
    const handleTikTokClick = () => {
        window.open(
            "https://tiktok.com/@gluten.freends?_r=1&_t=ZN-96RWKXZxhby",
            "_blank"
        )
    }

    return (
        <motion.div
            className={styles.wrapper}
            variants={item}
        >
            <h1 className={styles.title}>
                {t('footer.follow')}
            </h1>
            <div className={styles.horizontalBody}>
                <InstagramSvg width={30} height={30} onClick={handleInstagramClick}/>
                <TikTokSvg width={32} height={32} onClick={handleTikTokClick}/>
            </div>
        </motion.div>
    )
}